import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { getApiUrl, getEnvironment } from "./config";
import { Worker } from '@react-pdf-viewer/core';


console.log("----environment---", getEnvironment());


const container = document.getElementById('root');

// Create a root.
const root = ReactDOM.createRoot(container);

// Initial render: Render an element to the root.
root.render(
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.13.216/build/pdf.worker.min.js">
        <App />
    </Worker>
);


// ReactDOM.render(
//  ,
//   document.getElementById("root")
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();